import { TicketGroup } from '@interfaces/ticketevolution/tikets';
import { useBuildPackagesStore } from '@store/build-package-store';
import { useTicketsStore } from '@store/tickets-store';
import { useMemo } from 'react';

/** Bundle cards and map labels show the upgrade over the included ticket. */
export function useTicketPriceOffset(tickets: readonly TicketGroup[]): number {
  const isBundle = useBuildPackagesStore((state) => state.isBundle);
  const quantity = useTicketsStore((state) => state.ticketsQuantity);

  return useMemo(() => {
    if (!isBundle) return 0;
    const minimum = tickets.reduce(
      (price, ticket) =>
        ticket.splits.includes(quantity)
          ? Math.min(price, ticket.retail_price)
          : price,
      Infinity
    );
    return Number.isFinite(minimum) ? minimum : 0;
  }, [isBundle, quantity, tickets]);
}
